export default {
    init: function ($element) {
        "use strict";
        var _this = this;

        _this.$body = $element;
        _this.$overlay = $element.find('.overlay');

        return _this;
    },

    activate: function () {
        var _this = this,
            $bars = _this.$body.find('.bars'),
            $sideBarToggle = _this.$body.find('#sidebar-menu-toggler'),
            $switchAppSelectMenu = _this.$body.find("#toggle-menu"),
            $dataClose = $( '.nav [data-close="true"]' );

        // Unbind the previous click event
        $bars.off( 'click' );
        $sideBarToggle.off( 'click' );
        $switchAppSelectMenu.off( 'click' );

        // Open left sidebar panel
        $bars.on('click', function () {
            _this.$body.toggleClass('overlay-open');

            if (_this.$body.hasClass('overlay-open')) {
                _this.$overlay.fadeIn();
                _this.$body.removeClass('sidebar-closed');
            } else {
                _this.$overlay.fadeOut();
            }
        });

        $sideBarToggle.on('click', function () {
            _this.$body.toggleClass('sidebar-closed');

            $.each($(".menu .list li"), function (i, val) {
                const $el = $(val);
                const $activeAnchors = $el.find("a:eq(0)");

                if (_this.$body.hasClass('sidebar-closed')) {
                    // Hide all parent menu text labels
                    $activeAnchors.next().hide();
                    $el.find("a").removeClass("toggled");
                    // When toggled back, show the sub-menus of the active parent menu
                } else if ($el.hasClass("active")) {
                    $activeAnchors.addClass("toggled");
                    $activeAnchors.next().show();
                }
            });
        });

        // Toggle switch app menu in the header section
        $switchAppSelectMenu.on('click', function () {
            const $arrowPointer = _this.$body.find("#arrow-indicator");
            const $toggleSwitchMenu = _this.$body.find("#toggle-switch-menu");

            $toggleSwitchMenu.toggleClass("switch-menu__toggle");
            if ($toggleSwitchMenu.hasClass("switch-menu__toggle")) {
                $arrowPointer.html("arrow_drop_up")
            } else {
                $arrowPointer.html("arrow_drop_down")
            }
        });

        //Close collapse bar on click event
        $dataClose.on('click', function () {
            var isVisible = $('.navbar-toggle')
                .is(':visible');
            var $navbarCollapse = $('.navbar-collapse');

            if (isVisible) {
                $navbarCollapse.slideUp(function () {
                    $navbarCollapse.removeClass('in')
                        .removeAttr('style');
                });
            }
        });
    }
};
